import { SuretyAccountId, SuretyIndemnityAgreementId, UploadedFile } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";

export const useAdminGetAccountIndemnityAgreementFile = (
	accountId: SuretyAccountId,
	indemnityAgreementId: SuretyIndemnityAgreementId,
) => {
	const { get } = useRequest();

	const indemnityAgreement = useQuery({
		queryKey: ["accounts", accountId, "indemnity-agreements", indemnityAgreementId, "file"],
		queryFn: async () =>
			await get<UploadedFile>(
				`/v2/admin/surety/accounts/${accountId}/indemnity-agreements/${indemnityAgreementId}/file`,
			),
		refetchOnMount: false,
		refetchOnReconnect: false,
	});

	return {
		indemnityAgreementFile: indemnityAgreement.data,
		indemnityAgreementFileError: indemnityAgreement.error,
		indemnityAgreementFileLoading: indemnityAgreement.isLoading,
	};
};
